import { getUtmFromQuery } from 'hooks/useWalletAuthentication';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ReferralSaver = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAndSaveReferralCode = async () => {
      const pathParts = location.pathname.split('/');
      const referralCode = pathParts[2];
      let shouldRedirect = false;

      if (pathParts[1] === 'referral' && referralCode) {
        shouldRedirect = true;

        const existingCode = localStorage.getItem('referralCode');
        const utm = getUtmFromQuery();

        if (utm) {
          localStorage.setItem('utm', utm);
        }

        if (!existingCode) {
          localStorage.setItem('referralCode', referralCode);
        }
      }
      if (shouldRedirect) {
        navigate('/', { replace: true });
      }
    };

    checkAndSaveReferralCode();
  }, [navigate, location.pathname]);

  return null;
};

export default ReferralSaver;
